"use strict";
var aSet = require("../internals/a-set");
var has = require("../internals/set-helpers").has;
var size = require("../internals/set-size");
var getSetRecord = require("../internals/get-set-record");
var iterateSimple = require("../internals/iterate-simple");
var iteratorClose = require("../internals/iterator-close");
module.exports = function isSupersetOf(other) {
  var O = aSet(this);
  var otherRec = getSetRecord(other);
  if (size(O) < otherRec.size) return false;
  var iterator = otherRec.getIterator();
  return iterateSimple(iterator, function(e) {
    if (!has(O, e)) return iteratorClose(iterator, "normal", false);
  }) !== false;
};
